import { type Container } from '@packages/core/container';
import { HttpClient } from '@packages/core/http';

import { MockSsm5Client, Ssm5Client } from './ssm5';
import { StsBackendClient } from './sts-backend';

/**
 * Register all API clients from `@packages/clients` into the provided container.
 * Platform primitives ({@link HttpClient}) must already be registered as instances
 * by the app layer before anything is resolved.
 *
 * @param container - the container to register into
 * @returns the same container, with client registrations added
 */
export function registerClientPackage(container: Container): Container {
    container.register(StsBackendClient, [HttpClient]);
    // The SSM5 endpoints are not deployed yet; serve the scripted client until they are.
    container.factory(Ssm5Client, () => new MockSsm5Client(container.resolve(HttpClient)));

    return container;
}
